export abstract class II18NRepo {
	abstract loadTokens(langLocale: string): Promise<any>;
}

